<template>
  <v-row>
    <v-col>
      <v-col
        style="max-width: 100%"
        class="d-flex justify-space-between flex-wrap py-5 container"
      >
        <ToolbarTitles :title="title" />
      </v-col>
      <div class="container">
        <Table
          :title="title"
          :items="getLiquidation"
          :headers="allHeaders"
          :showAction="showAction"
          :actions="actions"
          :switchActions="switchActions"
          :openDialog="openList"
          :formkey="key"
          :selectedItem="selectedItem"
          @headersUpdated="updateHeaders"
        />
      </div>
      <CardAlert :showDialog="showDialog" :cancel="cancel" :confirm="confirm" :title="dialogTitle" />
      <Snackbar :alert="showAlert" :textAlert="textAlert" :color="colorAlert" />
      <v-dialog v-model="showView" :max-width="calculateDialogWidth">
        <ViewDetails
          :dialogVisible="showView"
          :title="titleView"
          :close="closeDialogView"
        />
      </v-dialog>
      <v-dialog v-model="loading" class="dialog__loader" :overlay-opacity="0.3">
        <loader :loading="loading" />
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
import liquidation from "../../store/liquidaciones/liquidation";
import CardAlert from "../Complement/CardAlert.vue";
import Table from "./Table.vue";
import Snackbar from "../Complement/Snackbar.vue";
import ViewDetails from "./ViewDetails.vue";
import Loader from "../Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    CardAlert,
    Snackbar,
    ViewDetails,
    Loader,
    ToolbarTitles,
  },
  name: "Liquidations",

  data() {
    return {
      title: this.$tc("nav.liquidations"),
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          sortable: true,
          visible: true,
          width:"20%"
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
          sortable: true,
          visible: true,
          width:"20%"
        },

        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
          width: "8%",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
          width: "8%",
        }, 
        {
          text: "Estado",
          value: "state",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
          visible: true,
          width: "8%",
        },
        {
          text: "Modelo",
          value: "modelName",
          class: "primary secondary--text",
          sortable: true,
          visible: true,
          width: "10%",
        },
        {
          text: "Tiene Interfaz",
          value: "hasInterface",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
          visible: true,
          width: "5%",
        },
        
        {
          text: "Cantidad Detalles",
          value: "detailsQuantity",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
          visible: true,
          width: "5%",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          align: "center",
          sortable: false,
          visible: true,
          width: "8%",
        },
        
      ],
      showAction: {
        type: true,
        label: this.$tc("liquidations.actions"),
        icon: "fa-plus",
      },

      showDialog: false,
      selectedItem: null,
      selectedIndex: null,
      actionsMap: {
        0: "signature",
        1: "removeSignature",
        2: "getSignature",
        3: "generateSalaryInterface",
        4: "close",
        5: "open",
        6: "getDetails",
        7: "getSalary",
      },
      showAlert: false,
      textAlert: "",
      colorAlert: "",
      key: 0,
      showView: false,
      tableData: [],
      headers2: [],
      closeDialog: false,
      titleView: "",
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    liquidation.dispatch("getLiquidation").then(() => {
      this.loading = false;
    });
  },
  computed: {
    getLiquidation() {
      return liquidation.state.liquidation;
    },
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    actions() {
      return [
        {
          text: this.$tc("liquidations.sign"),
          icon: "mdi-draw",
          disabled: null
        },
        {
          text: this.$tc("liquidations.removeSignature"),
          icon: "mdi-signature",
          disabled: null,
        },
        {
          text: this.$tc("liquidations.seeSignatures"),
          icon: "mdi-signature-image",
          disabled: null,
        },
        {
          text: this.$tc("liquidations.generateSalaryInterface"),
          icon: "mdi-cash",
          disabled: null,
        },
        {
          text: this.$tc("liquidations.close"),
          icon: "mdi-close-circle",
          disabled: null,
        },
        {
          text: this.$tc("liquidations.open"),
          icon:"mdi-lock-open-variant",
          disabled: null,
        },
        {
          text: this.$tc("liquidations.settlementDetails"),
          icon: "mdi-file-document",
          disabled: null,
        },
        {
          text: this.$tc("liquidations.interfaceDetailsWithSalaries"),
          icon: "mdi-file-account",
          disabled: null,
        },
      ];
    },
    dialogTitle() {
    if (this.selectedIndex !== null) {
      const action = this.actionsMap[this.selectedIndex];
      switch (action) {
        case "signature":
          return this.$tc("liquidations.toSingConfirm");
        case "removeSignature":
          return this.$tc("liquidations.removeSignConfirm");
        case "generateSalaryInterface":
          return this.$tc("liquidations.generateInterfaceConfirm");
        case "close":
          return this.$tc("liquidations.closeConfirm");
        case "open":
          return this.$tc("liquidations.toOpenConfirm");
        default:
          return this.$tc("liquidations.defaultConfirm");
      }
    }
    return "";
  },
    calculateDialogWidth() {
      const headerLength = liquidation.state.headers.length;
      const maxWidth = headerLength > 5 ? "100%" : "650px";
      return maxWidth;
    },
  },
  methods: {
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    async switchActions(index) {
      this.selectedIndex = index;
      console.log(index)
      if (
        this.actions[index] == this.actions[0] ||
        this.actions[index] == this.actions[1] ||
        this.actions[index] == this.actions[3] ||
        this.actions[index] == this.actions[4] ||
        this.actions[index] == this.actions[5]
      ) {
        this.showDialog = true;
      } else {
        await this.confirm();
        this.showView = true;
      }
    },
    async confirm() {
      this.loading = true;
      if (
        this.selectedIndex !== null &&
        this.selectedItem !== null &&
        this.actionsMap.hasOwnProperty(this.selectedIndex)
      ) {
        const action = this.actionsMap[this.selectedIndex];
        this.completeTitle(action);
        console.log("action", action)
        await liquidation
          .dispatch(action, this.selectedItem)
          .then(() => {
            liquidation.dispatch("getLiquidation");
            this.alert(
              this.$tc("liquidations.success"),
              "primary",
              !this.showAlert
            );
          })
          .catch((error) => {
            this.alert(
              error.response.data.error.message,
              "error",
              !this.showAlert
            );
          });
      }
      this.defaultAction();
    },

    cancel() {
      this.defaultAction();
    },
    defaultAction() {
      this.loading = false;
      this.showDialog = false;
      this.selectedIndex = null;
      this.selectedItem = null;
    },
    alert(text, color, alert) {
      this.showAlert = alert;
      this.textAlert = text;
      this.colorAlert = color;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
    },
    openList(item) {
      this.selectedItem = item;
      this.disableActions();
      this.key++;
    },
    closeDialogView() {
      this.showView = false;
      liquidation.commit("setHeaders", []);
      liquidation.commit("setRows", []);
      liquidation.commit("setResetVisibleColumns");
    },
    disableActions() {
      this.actions.forEach((action, index) => {
        switch (index) {
          case 0:
            action.disabled = !this.selectedItem.canSign;
            break;
          case 1:
            action.disabled = !this.selectedItem.canRetire;
            break;
          case 3:
            action.disabled = !this.selectedItem.canDoInterface;
            break;
          case 4:
            action.disabled = !this.selectedItem.canDoInterface;
            break;
          case 5 :
            action.disabled = this.selectedItem.state==="Abierta";
            break;
          default:
            action.disabled = false;
            break;
        }
      });
    },
    completeTitle(action) {
      switch (action) {
        case "getSignature":
          this.titleView = this.$tc("liquidations.seeSignatures");
          break;
        case "getDetails":
          this.titleView = this.$tc("liquidations.settlementDetails");
          break;
        case "getSalary":
          this.titleView = this.$tc(
            "liquidations.interfaceDetailsWithSalaries"
          );
          break;
        default:
          break;
      }
    },
    completeConfirmTitle(action){
      console.log(action)
    }
  },
};
</script>
<style>
.container {
  max-width: 100%;
}
</style>
